import { useState } from "react";
import { Grid, Button, Typography } from "@mui/material";
import AlertBar from "../utils/AlertBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTitle } from "../utils/useTitle";

const AccountConfirmation = () => {
  useTitle("Account Confirmation");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const handleButtonClick = async () => {
    try {
      navigate("/signin");
    } catch (error) {
      console.error("Error:", error);
      setErrors({ error: true });
      setErrorMessage(t("auth.alertMsg.error4"));
    }
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6} container justify="center" alignItems="center">
          <Grid
            container
            direction="column"
            spacing={3}
            style={{ maxWidth: "800px", padding: "20px", marginLeft: "70px" }}
          >
            <Grid item>
              <h1>{t("auth.header.accountConfirmation")}</h1>
              <Typography variant="h5" gutterBottom>
                {t("auth.msg.accountConfirmation")}
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="success"
                fullWidth
                size="large"
                style={{ height: "55px" }}
                onClick={handleButtonClick}
              >
                {t("auth.btnText.accountConfirmation")}
              </Button>
            </Grid>

            <Grid item></Grid>
          </Grid>
        </Grid>

        {/* Right Side (6 columns) */}
        <Grid item xs={6} style={{ overflow: "hidden" }}>
          <div style={{ width: "100%", height: "100vh" }}>
            <img
              src="assets/images/banner1.jpg"
              alt="Signin"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </Grid>
      </Grid>

      <AlertBar
        open={Object.values(errors).some((error) => error)}
        message={errorMessage}
        severity={"error"}
        onClose={() => setErrors({})}
      />
    </>
  );
};

export default AccountConfirmation;
